/* eslint-disable */
import { useTranslation } from "react-i18next";
import {
  Avatar,
  Button,
  FormControl,
  InputAdornment,
  Paper,
  Radio,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "./AssignTopicModal.module.scss";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { connect } from "react-redux";

function AssignTopicModal({
  handleClose,
  setAssignee,
  currentSystemUsers,
  topidId,
  user,
  getCurrentSystemUsers,
  slug,
}) {
  const { t } = useTranslation();
  const [currentAgentId, setCurrentAgentId] = useState("");
  const [input, setInput] = useState("");
  const [allAgents, setAllAgents] = useState([]);

  useEffect(() => {
    getCurrentSystemUsers({
      system: slug,
      noPagination:true,
      onSuccess: (res) => {
        setAllAgents(res)
      },
    });
  }, []);

  const searchInput = async (input) => {
    const filteredAgents = allAgents.filter((agent) =>
      agent.name.toLowerCase().includes(input.toLowerCase())
    );
    setInput(input);
    setAllAgents(filteredAgents);
    if (input === "") {
      setAllAgents(currentSystemUsers);
    }
  };
  useEffect(() => {
    const foundIndex = allAgents.findIndex((obj) => {
      return obj._id === user._id;
    });
    const newAgents = currentSystemUsers.unshift(
      currentSystemUsers.splice(foundIndex, 1)[0]
    );
  }, []);

  return (
    <Paper className={styles["assign-topic-modal"]}>
      {window.innerWidth < 900 ? (
        <div>
          <div className={styles["assign-topic-heading-container"]}>
            <h3>{t("modals:assignTopic")}</h3>
            <CloseIcon onClick={handleClose} />
          </div>
          <FormControl style={{ width: "100%" }}>
            <TextField
              value={input}
              onChange={(e) => searchInput(e.target.value)}
              sx={{ padding: "10px" }}
              placeholder={t("searchByName")}
              size="small"
              variant="outlined"
              id="search-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <div className={styles["select-agent"]}>
            {allAgents?.map((agent, index) => (
              <div className={styles.agent} key={index}>
                <Radio
                  onChange={(e) => {
                    setCurrentAgentId(e.target.value);
                  }}
                  checked={agent._id == currentAgentId}
                  sx={{
                    "&.Mui-checked": {
                      color: "#0DC1CE",
                    },
                  }}
                  value={agent._id}
                />
                <Avatar src={agent?.avatar} />
                <p>{agent.name}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className={styles["assign-topic-heading-container"]}>
            <h3>{t("modals:assignTopic")}</h3>
            <CloseIcon onClick={handleClose} />
          </div>
          <FormControl>
            <TextField
              value={input}
              onChange={(e) => searchInput(e.target.value)}
              sx={{ padding: "10px" }}
              placeholder={t("searchByName")}
              size="small"
              variant="outlined"
              id="search-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <div className={styles["select-agent"]}>
            {allAgents?.map((agent, index) => (
              <div className={styles.agent} key={index}>
                <Radio
                  onChange={(e) => {
                    setCurrentAgentId(e.target.value);
                  }}
                  checked={agent._id == currentAgentId}
                  sx={{
                    "&.Mui-checked": {
                      color: "#0DC1CE",
                    },
                  }}
                  value={agent._id}
                />
                <Avatar src={agent?.avatar} />
                <p>{agent.name}</p>
              </div>
            ))}
          </div>
        </>
      )}

      <Paper elevation={10} style={{ padding: "10px" }}>
        <Button
          onClick={() => {
            setAssignee(currentAgentId);
            handleClose();
          }}
          disableElevation
          disableRipple
          disableFocusRipple
          variant="contained"
          sx={{
            width: "100%",
            color: "white",
            backgroundColor: "#01d088",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#01d088",
            },
          }}
        >
          {t("select")}
        </Button>
      </Paper>
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  currentSystemUsers: state.users.currentSystemUsers,
  user: state.login.user,
});

export default connect(mapStateToProps)(AssignTopicModal);
